import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const technologicalTransferMembershipApi = generateNomenApi(
  `/technological-transfer/technological-transfer-membership`,
);

export const technologicalTransferMembershipOptions = generateNomenOptions(
  'technological-transfer-membership',
  technologicalTransferMembershipApi,
);
